import React from 'react';

/**
 * Reusable card component with various style options
 * 
 * @param {Object} props - Component props
 * @param {string} props.variant - Card style variant ('default', 'hover', 'feature', 'team')
 * @param {string} props.className - Additional classes to apply
 * @param {ReactNode} props.children - Card content
 * @param {boolean} props.withHover - Whether to add hover effects
 * @param {string} props.padding - Padding size ('none', 'sm', 'md', 'lg')
 */
const Card = ({
  variant = 'default',
  className = '',
  children,
  withHover = true,
  padding = 'md',
  ...props
}) => {
  // Variant classes
  const variantClasses = {
    default: 'bg-white border border-gray-100',
    feature: 'bg-white border border-gray-100 hover:border-blue-100',
    highlight: 'bg-gradient-to-br from-blue-50 to-blue-100',
    dark: 'bg-gray-900 text-white',
    transparent: 'bg-white/10 backdrop-blur-sm border border-white/20',
    team: 'bg-white overflow-hidden h-full flex flex-col',
  }[variant];

  // Padding classes
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }[padding];

  // Hover effect classes
  const hoverClasses = withHover
    ? 'transition-all duration-500 hover:shadow-xl card-hover'
    : '';

  // Default card classes
  const cardClasses = `
    rounded-2xl 
    shadow-lg 
    ${variantClasses} 
    ${paddingClasses} 
    ${hoverClasses} 
    ${className}
  `;

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export default Card;